import { call, select } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import { setSettings } from '../redux/lists'

export default function * requestChangeListSettings (action) {
  const { id, settings } = action.payload

  const state = yield select()

  const currentSettings = state['view-myboard'].lists[id].settings

  const newSettings = {
    ...currentSettings,
    ...settings
  }

  const optimisticAction = yield optimisticPut(setSettings({
    id,
    settings: newSettings
  }))

  try {
    yield call(apiAction, 'ChangeVListSettings', {
      id,
      settings: newSettings
    })

    yield optimisticAction.commit()
  } catch (error) {
    yield optimisticAction.revert()

    throw error
  }
}
